
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/influencers/[itemID]",
      function () {
        return require("private-next-pages/product/influencers/[itemID].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/influencers/[itemID]"])
      });
    }
  